var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"initiator",style:({ height: '1px', 'margin-bottom': '1px' })},[_vm._v(" ")]),_vm._v(" "),_c('div',{style:({ height: '1px' })},[_vm._v(" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }